import { compose } from 'redux';
import { WithFetchDatasFromCMS, WithFetchDatasFromCMSInputProps, WithCMSSEO } from 'modules/shared-cms/hocs';

import { HomeProps } from './home-type';
import { QUERY } from './home-query';
import { HomeLoader } from './home-loader';

const enhancer = compose<React.ComponentType<WithFetchDatasFromCMSInputProps>>(
    WithFetchDatasFromCMS<HomeProps>(QUERY, HomeLoader, 'queryCatalogueLandingContents'),
    WithCMSSEO(),
);
export default enhancer;
